// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.risk-budget-request .accordion-connection .card .card-header button.btn {
  padding-left: 20px;
}
.risk-budget-request table.table-risk {
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;
  display: block;
  margin-bottom: 2.4rem;
}
.risk-budget-request .table.table-risk {
  background-color: #fff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.3);
}
.risk-budget-request .table-risk td, .risk-budget-request .table-risk th {
  font-size: 1.28rem;
}
.risk-budget-request .table-risk td:last-child, .risk-budget-request .table-risk th:last-child {
  border-right: none;
}
.risk-budget-request .table.table-risk thead {
  background-color: #f7f7f7;
}
.risk-budget-request .table.table-risk tr:first-child td {
  border-top: none;
}
.risk-budget-request .table.table-risk thead th {
  border-bottom: 1px solid #dee2e6;
}
.risk-budget-request .table.table-risk th:first-child {
  width: 25%;
}
.risk-budget-request .table.table-risk th:nth-child(2) {
  width: 35%;
}
.risk-budget-request .table.table-risk th:nth-child(3) {
  width: 35%;
}
.risk-budget-request .table.table-risk td:first-child {
  font-weight: 600;
}
.risk-budget-request .table.table-risk td:nth-child(2), .risk-budget-request .table.table-risk td:nth-child(3) {
  padding-top: 7px;
  padding-bottom: 7px;
  vertical-align: middle;
}
.risk-budget-request .risk-label {
  border: 1px solid #f7f7f7;
  padding: 3px 15px;
  border-radius: 4px;
  background-color: #f7f7f7;
  margin-bottom: 0;
  min-width: 70px;
  text-align: center;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
